import { render, staticRenderFns } from "./AccordianItem.vue?vue&type=template&id=37a54fe4&scoped=true&"
import script from "./AccordianItem.vue?vue&type=script&lang=js&"
export * from "./AccordianItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a54fe4",
  null
  
)

export default component.exports